import { Center, Spinner } from '@chakra-ui/react'

export function Loader({ img }) {
  return (
    <Center
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      width="100%"
      height="100%"
      bg="rgba(255, 255, 255, 0.5)"
      zIndex="1"
    >
      {img && <img src={img} alt="Carregando" />}
      {!img && <Spinner data-testid="spinner" thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />}
    </Center>
  )
}
